import React from 'react';
import { Typography } from '@mui/material';
import AddressLabel from './AddressLabel';

const PositionLabel = ({ position, attributeKey, positionAttributes }) => {
  // If it's an address attribute, use the special AddressLabel
  if (attributeKey === 'address') {
    return <AddressLabel position={position} />;
  }
  // Otherwise use a generic label from positionAttributes
  const labelText = positionAttributes.hasOwnProperty(attributeKey)
    ? positionAttributes[attributeKey].name
    : attributeKey;
  return (
    <Typography variant="body2">
      {labelText}
    </Typography>
  );
};

// Expected props:
// position: Object (Position) - can be null
// attributeKey: string - key of the attribute to display
// positionAttributes: Object - dictionary of position attributes

export default PositionLabel;
